import React from "react";
import track from "react-tracking";
import { Link } from "react-router-dom";

import { Text } from "@metrea-ui/v2";

const Designer_Page = () => {
	return (
		<>
			<Text textStyle="3xl">Designer page</Text>
			<h5>
				<ul>
					<li>
						<Link to={"/baseline/edit"}>Baseline Management</Link>
					</li>
				</ul>
			</h5>
		</>
	);
};

export const Designer = track(
	{ page: "Designer" },
	{ dispatchOnMount: (contextData) => ({ event: "pageLoaded" }) }
)(Designer_Page);
